const pageTitles = {
  pageMgn: "Page Management",
  userMgn: "User Management",
  settings: "Settings",
  accessControl: "Access Control",
  orgChart: "Organizational Chart",
  appointmentParameters: "Appointment Parameters",
  appointment: "Appointment",
  processTypes: "Process Types",
  workflows: "Workflows",
  leaveRequests: "Leave Requests",
  myTasks: "My Tasks",
  myRequests: "My Requests",
  leaveSettings: "Leave Settings",
  bonusTypes: "Bonus Types",
  bonusRequests: "Team Bonus Requests",
  userDocumentType: "Document Types",
  announcements: "Announcements",
  desktopManagement: "Desktop Management",
  messageCategories: "Message Categories",
  userOrgInfo: "My Organization Information",
  messages: "Messages",
  workflowAssignments: "Workflow Assignments",
  tickets: "Tickets",
  ticketTypes: "Ticket Types",
  tasks: "Tasks",
  auditorAssignments: "Auditor Assignments"
};

export const getPageTitle = (pageName) => {
  return pageTitles[pageName] || "Dashboard";
}; 